import { PaletteMode, PaletteOptions } from '@mui/material';
import { grey } from './colors';

export const border = (mode: PaletteMode): PaletteOptions['border'] => {
  return mode === 'light'
    ? {
        prominent: grey[300],
        subtle: grey[150],
      }
    : {
        prominent: grey[600],
        subtle: grey[850],
      };
};
